import { render, staticRenderFns } from "./Closed.vue?vue&type=template&id=3a220b0d&scoped=true&"
import script from "./Closed.vue?vue&type=script&lang=js&"
export * from "./Closed.vue?vue&type=script&lang=js&"
import style0 from "./Closed.vue?vue&type=style&index=0&id=3a220b0d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a220b0d",
  null
  
)

export default component.exports